module.exports = {"TXTWCL_There_are_no_outrights_availab_ELL":{"id":"TXTWCL_There_are_no_outrights_availab_ELL","defaultMessage":"アウトライトがありません。"}}